/**
 * Returns name of first key in specified object.
 * @param obj Any object.
 */
export const nameof = (obj: Record<string, unknown>) => Object.keys(obj)[0];
